import React from "react";

export default function EmptyList() {
  return (
    <div className="empty">
      <span>List empty</span>
    </div>
  );
}